import { useEffect } from 'react';
import { useAuthStore, useLoginStore, useUserStore } from '@lib/store';
import { useRouteHook } from '@shared/hook';
import { RoutePaths, SessionStorageUtils } from '@shared/utils';
import { DUOForm, LoginForm } from './widgets';
import { Contacts, Logo, Spinner } from '@shared/widgets';

export const LoginPage = () => {
  const { navigate } = useRouteHook();

  const { loading, success, data } = useLoginStore();
  const authStore = useAuthStore();
  const userStore = useUserStore();

  const token = SessionStorageUtils.getToken();

  useEffect(() => {
    if (token) navigate(RoutePaths.dashboard.onNavigate());
  }, [token]);

  useEffect(() => {
    if (loading || !success || !data) return;

    if (data.status === 'allow') {
      authStore.authSuccess(data);
      userStore.authSuccess(data);
    } else if (data.status === 'locked_out') {
      navigate(RoutePaths.recovery.onNavigate());
    }
  }, [loading, success, data]);

  return (
    <div className='public-page'>
      <div className='relative mx-auto flex min-h-screen w-full max-w-[300px] flex-col justify-center py-10 text-[#fff]'>
        {loading && <Spinner />}
        {!loading && (
          <div className='flex min-h-[602px] flex-col justify-center'>
            <div className='mx-auto mb-13'>
              <Logo width='210' height='28' />
            </div>
            {data?.status === 'auth' ? <DUOForm devices={data?.devices} token={data?.temp_token} /> : <LoginForm />}
            <Contacts />
          </div>
        )}
      </div>
    </div>
  );
};
